import type {HistoryState} from 'vue-router'
import UUIDBase from '../UUIDBase'
import User from '../user/User'

export const zeissCardI18nMessages = {
  en: {
    system: 'System',
    zeissCard: 'ZEISS Card',
    zeissCardSettings: 'ZEISS Card - Settings',
    customerName: 'Customer Name',
    orderNumber: 'Order Number',
    results: 'Results',
    lensType: 'Lens Type',
    practitioner: 'Practitioner',
    saveAndPrint: 'Save & Print',
    created: 'ZEISS card was created successfully',
    updated: 'ZEISS card was updated successfully',
    editZeissCard: 'Edit ZEISS Card',
    settingsSaved: 'Settings were saved successfully',
    customerNameRequired: 'Customer name is required',
    fieldRequired: 'Required',
    lensTypeRequired: 'Lens type is required',
    practitionerRequired: 'Practitioner is required',
    date: 'Date',
    print: 'Print',
    saveCard: 'Save Card'
  },
  ar: {
    system: 'النظام',
    zeissCard: 'بطاقة ZEISS',
    zeissCardSettings: 'بطاقة ZEISS - الإعدادات',
    customerName: 'اسم العميل',
    orderNumber: 'رقم الطلب',
    results: 'النتائج',
    lensType: 'نوع العدسة',
    practitioner: 'الفاحص',
    saveAndPrint: 'حفظ وطباعة',
    created: 'تم إنشاء بطاقة ZEISS بنجاح',
    updated: 'تم تحديث بطاقة ZEISS بنجاح',
    editZeissCard: 'تعديل بطاقة ZEISS',
    settingsSaved: 'تم حفظ الإعدادات بنجاح',
    customerNameRequired: 'اسم العميل مطلوب',
    fieldRequired: 'مطلوب',
    lensTypeRequired: 'نوع العدسة مطلوب',
    practitionerRequired: 'الفاحص مطلوب',
    date: 'التاريخ',
    print: 'طباعة',
    saveCard: 'حفظ البطاقة'
  }
}

export interface ZeissCardSettings {
  practitioners: string[]
  lensTypes: string[]
}

export default class ZeissCard extends UUIDBase {
  static ENDPOINT = '/examination/zeiss-cards'
  static SETTINGS_ENDPOINT = '/examination/zeiss-cards/settings'
  static CUSTOMER_NAMES_ENDPOINT = '/examination/zeiss-cards/customer-names'

  static from(json: Record<string, unknown> | ZeissCard) {
    return Object.assign(new ZeissCard(), json)
  }

  static toHistoryState(card: ZeissCard): HistoryState {
    return {card: JSON.parse(JSON.stringify(card))}
  }

  userID: string | undefined
  user: User | undefined

  customerName = ''
  orderNumber = ''

  odSPH: number | undefined
  odCYL: number | undefined
  odAXIS: number | undefined
  odADD: number | undefined

  osSPH: number | undefined
  osCYL: number | undefined
  osAXIS: number | undefined
  osADD: number | undefined

  lensType = ''
  practitioner = ''
}
